import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [selected, setSelected] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
          Browse Vigorbuy Spreadsheet Categories
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-lg mx-auto">
          Select a category below to explore curated Vigorbuy Spreadsheet product finds on our main website.
        </p>

        <div className="relative">
          <select
            value={selected}
            onChange={handleChange}
            className="w-full appearance-none bg-background-100 border border-background-300 rounded-lg px-5 py-3.5 pr-12 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-100 transition-all"
          >
            <option value="" disabled>— Choose a Category —</option>
            {categories.map((cat) => (
              <option key={cat.slug} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
            <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}